import { render, staticRenderFns } from "./FilterView.vue?vue&type=template&id=0b71a0c8"
import script from "./FilterView.vue?vue&type=script&lang=js"
export * from "./FilterView.vue?vue&type=script&lang=js"
import style0 from "./FilterView.vue?vue&type=style&index=0&id=0b71a0c8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports